module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-toolbar', {
    staticStyle: {
      "position": "fixed"
    },
    attrs: {
      "dense": ""
    }
  }, [_c('v-btn', {
    staticClass: "orange darken-2 white--text",
    nativeOn: {
      "click": function($event) {
        return _vm.terugClicked($event)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": "",
      "left": ""
    }
  }, [_vm._v("arrow_back")]), _vm._v("Terug")], 1), _vm._v(" "), _c('v-btn', {
    class: {
      grey: _vm.AlgemeenSelected
    },
    staticStyle: {
      "margin": "0px",
      "margin-left": "20px"
    },
    attrs: {
      "disabled": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.AlgemeenClicked($event)
      }
    }
  }, [_vm._v("Algemeen")]), _vm._v(" "), _c('v-btn', {
    class: {
      grey: _vm.OnderhoudSelected
    },
    staticStyle: {
      "margin": "0px"
    },
    attrs: {
      "disabled": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.OnderhoudClicked($event)
      }
    }
  }, [_vm._v("Onderhoud")]), _vm._v(" "), _c('v-btn', {
    class: {
      grey: _vm.KeuringSelected
    },
    staticStyle: {
      "margin": "0px"
    },
    attrs: {
      "disabled": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.KeuringClicked($event)
      }
    }
  }, [_vm._v("Keuring")]), _vm._v(" "), _c('v-btn', {
    class: {
      grey: _vm.BestandenSelected
    },
    staticStyle: {
      "margin": "0px"
    },
    attrs: {
      "disabled": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.BestandenClicked($event)
      }
    }
  }, [_vm._v("Bestanden")]), _vm._v(" "), _c('v-btn', {
    class: {
      grey: _vm.SteekkaartSelected
    },
    staticStyle: {
      "margin": "0px"
    },
    attrs: {
      "disabled": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.SteekkaartClicked($event)
      }
    }
  }, [_vm._v("Steekkaart")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue white--text",
    staticStyle: {
      "margin": "0px"
    },
    attrs: {
      "disabled": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.afdrukkenClicked($event)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("print")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "green white--text",
    staticStyle: {
      "margin": "0px"
    },
    attrs: {
      "disabled": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.opslaanClicked($event)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("save")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "red white--text",
    staticStyle: {
      "margin": "0px"
    },
    attrs: {
      "disabled": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.verwijderenClicked($event)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("delete")])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "50px"
    }
  }), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "text-xs-center elevation-12",
    staticStyle: {
      "width": "60%",
      "min-width": "400px",
      "margin-left": "auto",
      "margin-right": "auto",
      "margin-top": "20px",
      "margin-bottom": "20px",
      "padding": "10px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "120px",
      "height": "120px",
      "margin": "auto",
      "padding-top": "20px",
      "padding-left": "20px"
    }
  }, [_c('v-progress-circular', {
    staticClass: "orange--text",
    attrs: {
      "indeterminate": "",
      "size": 80,
      "width": 5
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }]
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.AlgemeenSelected),
      expression: "AlgemeenSelected"
    }],
    staticClass: "text-xs-center elevation-12",
    staticStyle: {
      "width": "60%",
      "min-width": "400px",
      "margin-left": "auto",
      "margin-right": "auto",
      "margin-top": "20px",
      "margin-bottom": "20px",
      "padding": "10px"
    }
  }, [_c('v-layout', {
    staticStyle: {
      "margin": "auto",
      "padding": "auto",
      "margin-right": "0px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "right",
      "font-weight": "bold"
    }
  }, [_vm._v("\n                Soort:\n              ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "left",
      "margin-left": "10px"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.soorttxt) + "\n              ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "right",
      "font-weight": "bold"
    }
  }, [_vm._v("\n                Volgnr:\n              ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "left",
      "margin-left": "10px"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.volgnr) + "\n              ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "right",
      "margin-left": "10px"
    }
  }, [_c('v-btn', {
    staticStyle: {
      "margin": "0px",
      "height": "20px",
      "font-size": "10px"
    },
    attrs: {
      "disabled": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.wijzigvolgnrClicked($event)
      }
    }
  }, [_vm._v("wijzig volgnr")])], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "right",
      "font-weight": "bold",
      "height": "32px",
      "line-height": "32px"
    }
  }, [_vm._v("\n                Type:\n              ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "left",
      "margin-left": "10px"
    }
  }, [_c('v-text-field', {
    staticStyle: {
      "margin": "0px"
    },
    attrs: {
      "hide-details": ""
    },
    on: {
      "input": _vm.dataGewijzigd
    },
    model: {
      value: (_vm.omschrijving),
      callback: function($$v) {
        _vm.omschrijving = $$v
      },
      expression: "omschrijving"
    }
  })], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "right",
      "font-weight": "bold",
      "height": "32px",
      "line-height": "32px"
    }
  }, [_vm._v("\n                Merk:\n              ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "left",
      "margin-left": "10px"
    }
  }, [_c('v-text-field', {
    staticStyle: {
      "margin": "0px"
    },
    attrs: {
      "hide-details": ""
    },
    on: {
      "input": _vm.dataGewijzigd
    },
    model: {
      value: (_vm.merk),
      callback: function($$v) {
        _vm.merk = $$v
      },
      expression: "merk"
    }
  })], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "right",
      "font-weight": "bold",
      "height": "32px",
      "line-height": "32px"
    }
  }, [_vm._v("\n                Bouwjaar:\n              ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "left",
      "margin-left": "10px"
    }
  }, [_c('v-text-field', {
    staticStyle: {
      "margin": "0px"
    },
    attrs: {
      "hide-details": ""
    },
    on: {
      "input": _vm.dataGewijzigd
    },
    model: {
      value: (_vm.bouwjaar),
      callback: function($$v) {
        _vm.bouwjaar = $$v
      },
      expression: "bouwjaar"
    }
  })], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "right",
      "font-weight": "bold",
      "height": "32px",
      "line-height": "32px"
    }
  }, [_vm._v("\n                Serienr:\n              ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "left",
      "margin-left": "10px"
    }
  }, [_c('v-text-field', {
    staticStyle: {
      "margin": "0px"
    },
    attrs: {
      "hide-details": ""
    },
    on: {
      "input": _vm.dataGewijzigd
    },
    model: {
      value: (_vm.serienr),
      callback: function($$v) {
        _vm.serienr = $$v
      },
      expression: "serienr"
    }
  })], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "right",
      "font-weight": "bold",
      "height": "32px",
      "line-height": "32px"
    }
  }, [_vm._v("\n                HL\n              ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "left",
      "margin-left": "10px"
    }
  }, [_c('v-checkbox', {
    staticStyle: {
      "margin": "0px"
    },
    attrs: {
      "hide-details": ""
    },
    on: {
      "change": _vm.dataGewijzigd
    },
    model: {
      value: (_vm.HL),
      callback: function($$v) {
        _vm.HL = $$v
      },
      expression: "HL"
    }
  })], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "right",
      "font-weight": "bold",
      "height": "32px",
      "line-height": "32px"
    }
  }, [_vm._v("\n                VIK\n              ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "left",
      "margin-left": "10px"
    }
  }, [_c('v-checkbox', {
    staticStyle: {
      "margin": "0px"
    },
    attrs: {
      "hide-details": ""
    },
    on: {
      "change": _vm.dataGewijzigd
    },
    model: {
      value: (_vm.VIK),
      callback: function($$v) {
        _vm.VIK = $$v
      },
      expression: "VIK"
    }
  })], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "right",
      "font-weight": "bold",
      "height": "32px",
      "line-height": "32px"
    }
  }, [_vm._v("\n                RIE\n              ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "left",
      "margin-left": "10px"
    }
  }, [_c('v-checkbox', {
    staticStyle: {
      "margin": "0px"
    },
    attrs: {
      "hide-details": ""
    },
    on: {
      "change": _vm.dataGewijzigd
    },
    model: {
      value: (_vm.RIE),
      callback: function($$v) {
        _vm.RIE = $$v
      },
      expression: "RIE"
    }
  })], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "right",
      "font-weight": "bold",
      "height": "32px",
      "line-height": "32px"
    }
  }, [_vm._v("\n                CE\n              ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "left",
      "margin-left": "10px"
    }
  }, [_c('v-checkbox', {
    staticStyle: {
      "margin": "0px"
    },
    attrs: {
      "hide-details": ""
    },
    on: {
      "change": _vm.dataGewijzigd
    },
    model: {
      value: (_vm.CE),
      callback: function($$v) {
        _vm.CE = $$v
      },
      expression: "CE"
    }
  })], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "right",
      "font-weight": "bold",
      "height": "32px",
      "line-height": "32px"
    }
  }, [_vm._v("\n                IDV\n              ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "left",
      "margin-left": "10px"
    }
  }, [_c('v-checkbox', {
    staticStyle: {
      "margin": "0px"
    },
    attrs: {
      "hide-details": ""
    },
    on: {
      "change": _vm.dataGewijzigd
    },
    model: {
      value: (_vm.IDV),
      callback: function($$v) {
        _vm.IDV = $$v
      },
      expression: "IDV"
    }
  })], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('br')]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "right",
      "font-weight": "bold"
    }
  }, [_vm._v("\n                Huidige locatie:\n              ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.datlocstr) + "\n              ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "left",
      "margin-left": "10px"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.locdata,
      "item-text": "text",
      "item-value": "werfnr",
      "label": "",
      "single-line": "",
      "no-data-text": "Geen Gegevens"
    },
    on: {
      "change": _vm.dataGewijzigd
    },
    model: {
      value: (_vm.selectedWerfNr),
      callback: function($$v) {
        _vm.selectedWerfNr = $$v
      },
      expression: "selectedWerfNr"
    }
  })], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "right",
      "font-weight": "bold"
    }
  }, [_vm._v("\n                Vorige locaties:\n              ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "right"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "right"
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "left",
      "margin-left": "10px"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.selectedWerf2.text) + " " + _vm._s(_vm.datloc2str) + "\n              ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "left",
      "margin-left": "10px"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.selectedWerf3.text) + " " + _vm._s(_vm.datloc3str) + "\n              ")])])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.OnderhoudSelected),
      expression: "OnderhoudSelected"
    }],
    staticClass: "text-xs-center elevation-12",
    staticStyle: {
      "width": "60%",
      "min-width": "400px",
      "margin-left": "auto",
      "margin-right": "auto",
      "margin-top": "20px",
      "margin-bottom": "20px",
      "padding": "10px"
    }
  }, [_c('v-layout', {
    staticStyle: {
      "margin": "auto",
      "padding": "auto",
      "margin-right": "0px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "left",
      "margin-left": "10px"
    }
  }, [_c('b', [_vm._v("Soort:")]), _vm._v(" " + _vm._s(_vm.soorttxt) + "\n          ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "left",
      "margin-left": "10px"
    }
  }, [_c('b', [_vm._v("Volgnr:")]), _vm._v(" " + _vm._s(_vm.volgnr) + "\n          ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "left",
      "margin-left": "10px",
      "font-weight": "bold"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.omschrijving) + "\n          ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('br')]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "left",
      "margin-left": "10px"
    }
  }, [_vm._v("\n            defect\n          ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "left",
      "margin-left": "10px"
    }
  }, [_c('v-checkbox', {
    staticStyle: {
      "margin": "0px"
    },
    attrs: {
      "hide-details": ""
    },
    on: {
      "change": _vm.dataGewijzigd
    },
    model: {
      value: (_vm.defect),
      callback: function($$v) {
        _vm.defect = $$v
      },
      expression: "defect"
    }
  })], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "left",
      "margin-left": "10px"
    }
  }, [_vm._v("\n            vorstvrij\n          ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "left",
      "margin-left": "10px"
    }
  }, [_c('v-checkbox', {
    staticStyle: {
      "margin": "0px"
    },
    attrs: {
      "hide-details": ""
    },
    on: {
      "change": _vm.dataGewijzigd
    },
    model: {
      value: (_vm.vorstvrij),
      callback: function($$v) {
        _vm.vorstvrij = $$v
      },
      expression: "vorstvrij"
    }
  })], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('br')]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "margin": "0px",
      "padding": "0px",
      "padding-left": "10px"
    },
    attrs: {
      "xs4": ""
    }
  }, [_c('v-btn', {
    staticStyle: {
      "text-align": "center",
      "margin-left": "0px"
    },
    attrs: {
      "outline": _vm.datumingave,
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.datumingaveClick($event)
      }
    }
  }, [_vm._v("Datum-ingave")])], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "margin": "0px",
      "padding": "0px"
    },
    attrs: {
      "xs4": ""
    }
  }, [_c('v-btn', {
    staticStyle: {
      "text-align": "center",
      "margin-left": "0px"
    },
    attrs: {
      "outline": _vm.ureningave,
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.ureningaveClick($event)
      }
    }
  }, [_vm._v("Uren-ingave")])], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "margin": "0px",
      "padding": "0px",
      "padding-right": "10px"
    },
    attrs: {
      "xs4": ""
    }
  }, [_c('v-btn', {
    staticStyle: {
      "text-align": "center",
      "margin-left": "0px"
    },
    attrs: {
      "outline": _vm.infoingave,
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.infoingaveClick($event)
      }
    }
  }, [_vm._v("Info-ingave")])], 1), _vm._v(" "), _c('v-container', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.datumingave),
      expression: "datumingave"
    }],
    staticStyle: {
      "margin": "0px",
      "padding": "0px",
      "margin-left": "10px",
      "margin-right": "10px",
      "border-style": "solid",
      "border-width": "1px"
    }
  }, [_c('v-flex', {
    staticStyle: {
      "margin": "0px",
      "padding": "0px"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "left",
      "margin-left": "5px",
      "margin-right": "10px"
    }
  }, [_c('span', {
    staticClass: "group pa-1"
  }, [_c('v-icon', [_vm._v("event")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "15px"
    }
  }, [_vm._v("Datum volgend onderhoud:")]), _vm._v(" "), _c('div', {
    staticClass: "dateclass"
  }, [_c('datepicker', {
    attrs: {
      "selected": "dataGewijzigd",
      "placeholder": "__/__/____",
      "monday-first": "",
      "format": "dd/MM/yyyy",
      "language": "nl"
    },
    model: {
      value: (_vm.datumvolgend),
      callback: function($$v) {
        _vm.datumvolgend = $$v
      },
      expression: "datumvolgend"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "margin": "0px",
      "padding": "0px"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "left",
      "margin-left": "5px",
      "margin-right": "10px"
    }
  }, [_c('span', {
    staticClass: "group pa-1"
  }, [_c('v-icon', [_vm._v("event")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "15px",
      "margin-right": "18px"
    }
  }, [_vm._v("Datum vorig onderhoud:")]), _vm._v(" "), _c('div', {
    staticClass: "dateclass"
  }, [_c('datepicker', {
    attrs: {
      "selected": "dataGewijzigd",
      "placeholder": "__/__/____",
      "monday-first": "",
      "format": "dd/MM/yyyy",
      "language": "nl"
    },
    model: {
      value: (_vm.datumvorig),
      callback: function($$v) {
        _vm.datumvorig = $$v
      },
      expression: "datumvorig"
    }
  })], 1)], 1)])])], 1), _vm._v(" "), _c('v-container', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ureningave),
      expression: "ureningave"
    }],
    staticStyle: {
      "margin": "0px",
      "padding": "0px",
      "margin-left": "10px",
      "margin-right": "10px",
      "border-style": "solid",
      "border-width": "1px"
    }
  }, [_c('v-flex', {
    staticStyle: {
      "margin": "0px",
      "padding": "0px"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "right",
      "margin-left": "10px",
      "margin-right": "10px"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Huidige urenstand/kilometerstand",
      "prepend-icon": "timer",
      "hide-details": ""
    },
    on: {
      "input": _vm.dataGewijzigd
    },
    model: {
      value: (_vm.huidigeurenstand),
      callback: function($$v) {
        _vm.huidigeurenstand = $$v
      },
      expression: "huidigeurenstand"
    }
  })], 1)]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "margin": "0px",
      "padding": "0px"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "left",
      "margin-left": "5px",
      "margin-right": "10px"
    }
  }, [_c('span', {
    staticClass: "group pa-1"
  }, [_c('v-icon', [_vm._v("event")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "15px"
    }
  }, [_vm._v("Opgenomen op:")]), _vm._v(" "), _c('div', {
    staticClass: "dateclass"
  }, [_c('datepicker', {
    attrs: {
      "selected": "dataGewijzigd",
      "placeholder": "__/__/____",
      "monday-first": "",
      "format": "dd/MM/yyyy",
      "language": "nl"
    },
    model: {
      value: (_vm.datumurenopgenomenop),
      callback: function($$v) {
        _vm.datumurenopgenomenop = $$v
      },
      expression: "datumurenopgenomenop"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "margin": "0px",
      "padding": "0px"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "right",
      "margin-left": "10px",
      "margin-right": "10px"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Urenstand/kilometerstand vorig onderhoud",
      "prepend-icon": "timer",
      "hide-details": ""
    },
    on: {
      "input": _vm.dataGewijzigd
    },
    model: {
      value: (_vm.vorigeurenstand),
      callback: function($$v) {
        _vm.vorigeurenstand = $$v
      },
      expression: "vorigeurenstand"
    }
  })], 1)]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "margin": "0px",
      "padding": "0px"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "right",
      "margin-left": "10px",
      "margin-right": "10px"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Interval onderhoud (uren of km)",
      "prepend-icon": "timer",
      "hide-details": ""
    },
    on: {
      "input": _vm.dataGewijzigd
    },
    model: {
      value: (_vm.omde),
      callback: function($$v) {
        _vm.omde = $$v
      },
      expression: "omde"
    }
  })], 1)])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('br')]), _vm._v(" "), _c('v-container', {
    staticStyle: {
      "margin": "0px",
      "padding": "0px",
      "margin-left": "10px",
      "margin-right": "10px",
      "background-color": "lightgrey"
    }
  }, [_vm._v("\n        Onderhoudsinformatie\n      ")]), _vm._v(" "), _c('v-container', {
    staticStyle: {
      "margin": "0px",
      "padding": "0px",
      "margin-left": "10px",
      "margin-right": "10px",
      "border-style": "solid",
      "border-width": "1px"
    }
  }, [_c('v-flex', {
    staticStyle: {
      "margin": "0px",
      "padding": "0px"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "left",
      "margin-left": "5px",
      "margin-right": "10px"
    }
  }, [_c('span', {
    staticClass: "group pa-1"
  }, [_c('v-icon', [_vm._v("event")]), _vm._v(" "), _c('div', {
    staticClass: "dateclass"
  }, [_c('datepicker', {
    attrs: {
      "selected": "dataGewijzigd",
      "placeholder": "__/__/____",
      "monday-first": "",
      "format": "dd/MM/yyyy",
      "language": "nl"
    },
    model: {
      value: (_vm.datumNieuwOnderhoud),
      callback: function($$v) {
        _vm.datumNieuwOnderhoud = $$v
      },
      expression: "datumNieuwOnderhoud"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "margin": "0px",
      "padding": "0px",
      "margin-left": "10px",
      "margin-right": "10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-textarea', {
    staticClass: "input-group--focused",
    attrs: {
      "label": "Gegevens invullen",
      "hide-details": ""
    },
    model: {
      value: (_vm.nieuweonderhoudgegevens),
      callback: function($$v) {
        _vm.nieuweonderhoudgegevens = $$v
      },
      expression: "nieuweonderhoudgegevens"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "green white--text",
    staticStyle: {
      "padding": "0px",
      "margin-bottom": "0px"
    },
    attrs: {
      "small": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.nieuwOnderhoudClicked($event)
      }
    }
  }, [_c('v-icon', {
    staticStyle: {
      "padding": "0px"
    },
    attrs: {
      "dark": ""
    }
  }, [_vm._v("add")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-textarea', {
    staticClass: "input-group--focused",
    staticStyle: {
      "background-color": "lightgrey"
    },
    attrs: {
      "placeholder": "-geen historiek-",
      "hide-details": ""
    },
    model: {
      value: (_vm.onderhoudtekst),
      callback: function($$v) {
        _vm.onderhoudtekst = $$v
      },
      expression: "onderhoudtekst"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.KeuringSelected),
      expression: "KeuringSelected"
    }],
    staticClass: "text-xs-center elevation-12",
    staticStyle: {
      "width": "60%",
      "min-width": "400px",
      "margin-left": "auto",
      "margin-right": "auto",
      "margin-top": "20px",
      "margin-bottom": "20px",
      "padding": "10px"
    }
  }, [_c('v-layout', {
    staticStyle: {
      "margin": "auto",
      "padding": "auto",
      "margin-right": "0px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "left",
      "margin-left": "10px"
    }
  }, [_c('b', [_vm._v("Soort:")]), _vm._v(" " + _vm._s(_vm.soorttxt) + "\n          ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "left",
      "margin-left": "10px"
    }
  }, [_c('b', [_vm._v("Volgnr:")]), _vm._v(" " + _vm._s(_vm.volgnr) + "\n          ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "left",
      "margin-left": "10px",
      "font-weight": "bold"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.omschrijving) + "\n          ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('br')]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "margin": "0px",
      "padding": "0px",
      "padding-left": "10px"
    },
    attrs: {
      "xs6": ""
    }
  }, [_c('v-btn', {
    staticStyle: {
      "text-align": "center",
      "margin-left": "0px"
    },
    attrs: {
      "outline": _vm.keuringinex == 0,
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.keuringinexClick(0)
      }
    }
  }, [_vm._v("INTERN")])], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "margin": "0px",
      "padding": "0px"
    },
    attrs: {
      "xs6": ""
    }
  }, [_c('v-btn', {
    staticStyle: {
      "text-align": "center",
      "margin-left": "0px"
    },
    attrs: {
      "outline": _vm.keuringinex == 1,
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.keuringinexClick(1)
      }
    }
  }, [_vm._v("EXTERN")])], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "margin": "0px",
      "padding": "0px",
      "padding-left": "10px"
    },
    attrs: {
      "xs4": ""
    }
  }, [_c('v-btn', {
    staticStyle: {
      "text-align": "center",
      "margin-left": "0px"
    },
    attrs: {
      "outline": _vm.omdemaanden == 3,
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.omdemaandenClick(3)
      }
    }
  }, [_vm._v("3-maandelijks")])], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "margin": "0px",
      "padding": "0px"
    },
    attrs: {
      "xs4": ""
    }
  }, [_c('v-btn', {
    staticStyle: {
      "text-align": "center",
      "margin-left": "0px"
    },
    attrs: {
      "outline": _vm.omdemaanden == 6,
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.omdemaandenClick(6)
      }
    }
  }, [_vm._v("6-maandelijks")])], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "margin": "0px",
      "padding": "0px",
      "padding-right": "10px"
    },
    attrs: {
      "xs4": ""
    }
  }, [_c('v-btn', {
    staticStyle: {
      "text-align": "center",
      "margin-left": "0px"
    },
    attrs: {
      "outline": _vm.omdemaanden == 12,
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.omdemaandenClick(12)
      }
    }
  }, [_vm._v("jaarlijks")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('br')]), _vm._v(" "), _c('v-container', {
    staticStyle: {
      "margin": "0px",
      "padding": "0px",
      "margin-left": "10px",
      "margin-right": "10px",
      "border-style": "solid",
      "border-width": "1px"
    }
  }, [_c('v-flex', {
    staticStyle: {
      "margin": "0px",
      "padding": "0px"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "left",
      "margin-left": "5px",
      "margin-right": "10px"
    }
  }, [_c('span', {
    staticClass: "group pa-1"
  }, [_c('v-icon', [_vm._v("event")]), _vm._v(" "), _c('div', {
    staticClass: "dateclass"
  }, [_c('datepicker', {
    attrs: {
      "selected": "dataGewijzigd",
      "placeholder": "__/__/____",
      "monday-first": "",
      "format": "dd/MM/yyyy",
      "language": "nl"
    },
    model: {
      value: (_vm.datumNieuweKeuring),
      callback: function($$v) {
        _vm.datumNieuweKeuring = $$v
      },
      expression: "datumNieuweKeuring"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "margin": "0px",
      "padding": "0px",
      "margin-left": "10px",
      "margin-right": "10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-textarea', {
    staticClass: "input-group--focused",
    attrs: {
      "label": "Opmerkingen keuringsverslag",
      "hide-details": ""
    },
    model: {
      value: (_vm.nieuwekeuringgegevens),
      callback: function($$v) {
        _vm.nieuwekeuringgegevens = $$v
      },
      expression: "nieuwekeuringgegevens"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "green white--text",
    staticStyle: {
      "padding": "0px",
      "margin-bottom": "0px"
    },
    attrs: {
      "small": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.nieuwKeuringClicked($event)
      }
    }
  }, [_c('v-icon', {
    staticStyle: {
      "padding": "0px"
    },
    attrs: {
      "dark": ""
    }
  }, [_vm._v("add")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-textarea', {
    staticClass: "input-group--focused",
    staticStyle: {
      "background-color": "lightgrey"
    },
    attrs: {
      "placeholder": "-geen keuringsverslagen-",
      "hide-details": ""
    },
    model: {
      value: (_vm.keuringtekst),
      callback: function($$v) {
        _vm.keuringtekst = $$v
      },
      expression: "keuringtekst"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.BestandenSelected),
      expression: "BestandenSelected"
    }],
    staticClass: "text-xs-center elevation-12",
    staticStyle: {
      "width": "60%",
      "min-width": "400px",
      "margin-left": "auto",
      "margin-right": "auto",
      "margin-top": "20px",
      "margin-bottom": "20px",
      "padding": "10px"
    }
  }, [_c('v-layout', {
    staticStyle: {
      "margin": "auto",
      "padding": "auto",
      "margin-right": "0px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "left",
      "margin-left": "10px"
    }
  }, [_c('b', [_vm._v("Soort:")]), _vm._v(" " + _vm._s(_vm.soorttxt) + "\n          ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "left",
      "margin-left": "10px"
    }
  }, [_c('b', [_vm._v("Volgnr:")]), _vm._v(" " + _vm._s(_vm.volgnr) + "\n          ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "left",
      "margin-left": "10px",
      "font-weight": "bold"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.omschrijving) + "\n          ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('br')]), _vm._v(" "), _c('v-container', {
    staticStyle: {
      "margin": "0px",
      "padding": "0px",
      "margin-left": "10px",
      "margin-right": "10px",
      "border-style": "solid",
      "border-width": "1px"
    }
  }, [_c('v-flex', {
    staticStyle: {
      "margin": "0px",
      "padding": "0px"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "right",
      "margin-left": "10px",
      "margin-right": "10px"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Mapnaam op server",
      "prepend-icon": "folder",
      "hide-details": ""
    },
    model: {
      value: (_vm.mapnaam),
      callback: function($$v) {
        _vm.mapnaam = $$v
      },
      expression: "mapnaam"
    }
  })], 1)]), _vm._v(" "), (_vm.bestandenLoading) ? _c('v-flex', {
    staticStyle: {
      "text-align": "center",
      "margin": "20px"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.bestandenLoading) ? _c('v-list', {
    staticStyle: {
      "margin-left": "10px",
      "margin-right": "10px"
    }
  }, [_vm._l((_vm.filelist), function(item) {
    return [_c('v-list-tile', {
      nativeOn: {
        "click": function($event) {
          return _vm.clickFile(item)
        }
      }
    }, [_c('v-list-tile-content', [_vm._v("\n                " + _vm._s(item.title) + "\n              ")])], 1)]
  })], 2) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.SteekkaartSelected),
      expression: "SteekkaartSelected"
    }],
    staticClass: "text-xs-center elevation-12",
    staticStyle: {
      "width": "60%",
      "min-width": "400px",
      "margin-left": "auto",
      "margin-right": "auto",
      "margin-top": "20px",
      "margin-bottom": "20px",
      "padding": "10px"
    }
  }, [_c('v-layout', {
    staticStyle: {
      "margin": "auto",
      "padding": "auto",
      "margin-right": "0px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "right",
      "margin-left": "10px",
      "font-weight": "bold"
    }
  }, [_vm._v("\n              Nummer:\n          ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "left",
      "margin-left": "10px"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.soortIDshortTxt) + "\n          ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "right",
      "margin-left": "10px",
      "font-weight": "bold"
    }
  }, [_vm._v("\n              Vorstvrij:\n          ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "left",
      "margin-left": "10px"
    }
  }, [(_vm.vorstvrij) ? _c('div', [_vm._v("JA")]) : _vm._e(), (!_vm.vorstvrij) ? _c('div', [_vm._v("NEE")]) : _vm._e()])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "right",
      "margin-left": "10px",
      "font-weight": "bold"
    }
  }, [_vm._v("\n              Soort:\n          ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "left",
      "margin-left": "10px"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.soortdesc) + "\n          ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "right",
      "margin-left": "10px",
      "font-weight": "bold"
    }
  }, [_vm._v("\n              Defect:\n          ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "left",
      "margin-left": "10px"
    }
  }, [(_vm.defect) ? _c('div', [_vm._v("JA")]) : _vm._e(), (!_vm.defect) ? _c('div', [_vm._v("NEE")]) : _vm._e()])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('br')]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "right",
      "margin-left": "10px",
      "font-weight": "bold"
    }
  }, [_vm._v("\n              omschrijving:\n          ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "left",
      "margin-left": "10px"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.omschrijving) + "\n          ")])]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "background-color": "black",
      "height": "2px",
      "margin-top": "15px"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticStyle: {
      "width": "1px",
      "height": "2px"
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('br')]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "right",
      "margin-left": "10px",
      "font-weight": "bold"
    }
  }, [_vm._v("\n              Huidige locatie:\n          ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "left",
      "margin-left": "10px"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.selectedWerfNr) + " " + _vm._s(_vm.datlocstr) + "\n          ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "right",
      "margin-left": "10px"
    }
  }, [_vm._v("\n              voorgaande locatie 1:\n          ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "left",
      "margin-left": "10px"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.selectedWerf2.text) + " " + _vm._s(_vm.datloc2str) + "\n          ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "right",
      "margin-left": "10px"
    }
  }, [_vm._v("\n              voorgaande locatie 2:\n          ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "left",
      "margin-left": "10px"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.selectedWerf3.text) + " " + _vm._s(_vm.datloc3str) + "\n          ")])]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "background-color": "black",
      "height": "2px",
      "margin-top": "15px"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticStyle: {
      "width": "1px",
      "height": "2px"
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('br')]), _vm._v(" "), (_vm.ureningave) ? _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "right",
      "margin-left": "10px",
      "font-weight": "bold"
    }
  }, [_vm._v("\n              Urenstand:\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.ureningave) ? _c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "left",
      "margin-left": "10px"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.huidigeurenstand) + " u\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.ureningave) ? _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "right",
      "margin-left": "10px"
    }
  }, [_vm._v("\n              Vorig onderhoud:\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.ureningave) ? _c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "left",
      "margin-left": "10px"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.vorigeurenstand) + " u\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.ureningave) ? _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "right",
      "margin-left": "10px"
    }
  }, [_vm._v("\n              Interval onderhoud:\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.ureningave) ? _c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "left",
      "margin-left": "10px"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.omde) + " u\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.ureningave) ? _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "right",
      "margin-left": "10px"
    }
  }, [_vm._v("\n              nog\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.ureningave) ? _c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "left",
      "margin-left": "10px"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.omde + _vm.vorigeurenstand - _vm.huidigeurenstand) + " u voor volgend onderhoud\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.datumingave) ? _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "right",
      "margin-left": "10px",
      "font-weight": "bold"
    }
  }, [_vm._v("\n              Volgend onderhoud:\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.datumingave) ? _c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "left",
      "margin-left": "10px"
    }
  }, [_vm._v("\n            __/__/____\n          ")])]) : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "background-color": "black",
      "height": "2px",
      "margin-top": "15px"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticStyle: {
      "width": "1px",
      "height": "2px"
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('br')]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "background-color": "lightyellow",
      "font-weight": "bold"
    },
    attrs: {
      "xs12": ""
    }
  }, [_vm._v("Onderhoudsgeschiedenis")]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "background-color": "lightgrey",
      "word-break": "break-all",
      "white-space": "pre-line",
      "text-align": "left"
    },
    attrs: {
      "xs12": ""
    }
  }, [_vm._v(_vm._s(_vm.onderhoudtekst))]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "background-color": "lightyellow",
      "font-weight": "bold"
    },
    attrs: {
      "xs12": ""
    }
  }, [_vm._v("Keuringsgeschiedenis")]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "background-color": "lightgrey",
      "word-break": "break-all",
      "white-space": "pre-line",
      "text-align": "left"
    },
    attrs: {
      "xs12": ""
    }
  }, [_vm._v(_vm._s(_vm.keuringtekst))])], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "row": "",
      "justify-center": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "width": "350px",
      "absolute": "",
      "persistent": ""
    },
    model: {
      value: (_vm.showSaveDialog),
      callback: function($$v) {
        _vm.showSaveDialog = $$v
      },
      expression: "showSaveDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Wijzigingen opslaan?")])]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.saveDialogOpslaan($event)
      }
    }
  }, [_vm._v("Opslaan")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.saveDialogNietOpslaan($event)
      }
    }
  }, [_vm._v("Niet opslaan")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.saveDialogAnnuleren($event)
      }
    }
  }, [_vm._v("Annuleren")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "row": "",
      "justify-center": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "width": "350px",
      "absolute": "",
      "persistent": ""
    },
    model: {
      value: (_vm.showVerwijderDialog),
      callback: function($$v) {
        _vm.showVerwijderDialog = $$v
      },
      expression: "showVerwijderDialog"
    }
  }, [_c('v-card', {
    staticStyle: {
      "background-color": "red"
    }
  }, [_c('v-card-title', [_c('div', {
    staticClass: "headline white--text"
  }, [_vm._v("Machine verwijderen?")])]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.showVerwijderDialog = false
      }
    }
  }, [_vm._v("Annuleren")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.verwDialogVerwijderen($event)
      }
    }
  }, [_vm._v("Verwijderen")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "row": "",
      "justify-center": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "width": "350px",
      "absolute": "",
      "persistent": ""
    },
    model: {
      value: (_vm.showWijzigVolgnrDialog),
      callback: function($$v) {
        _vm.showWijzigVolgnrDialog = $$v
      },
      expression: "showWijzigVolgnrDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Wijzig soort/volgnr")])]), _vm._v(" "), _c('v-card-text', [_c('v-select', {
    attrs: {
      "items": _vm.soortendata,
      "item-text": "text",
      "item-value": "soortID",
      "return-object": "",
      "label": "soort",
      "single-line": "",
      "required": "",
      "no-data-text": "Geen Gegevens"
    },
    model: {
      value: (_vm.nieuweMachineSoort),
      callback: function($$v) {
        _vm.nieuweMachineSoort = $$v
      },
      expression: "nieuweMachineSoort"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "volgnr",
      "required": ""
    },
    model: {
      value: (_vm.nieuweVolgnr),
      callback: function($$v) {
        _vm.nieuweVolgnr = $$v
      },
      expression: "nieuweVolgnr"
    }
  }), _vm._v(" "), (_vm.TErrorShow) ? _c('div', {
    staticClass: "red--text"
  }, [_vm._v(_vm._s(_vm.TErrorWijzigVolgnr))]) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.showWijzigVolgnrDialog = false
      }
    }
  }, [_vm._v("Annuleren")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.WijzigVolgnrDialogClicked($event)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c933b60"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/materieeldetail.vue
// module id = 47
// module chunks = 3